import { render, staticRenderFns } from "./CustomTabs.vue?vue&type=template&id=6db02c4a&scoped=true"
import script from "./CustomTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTabs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomTabs.vue?vue&type=style&index=0&id=6db02c4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db02c4a",
  null
  
)

export default component.exports